import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.user');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-user',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.user/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageUserComponent implements OnInit {
    public stats: any = {};
    public datasets: any[] = [];
    public loading: boolean = true;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadStats();
        await this.service.render();
    }

    public async loadStats() {
        this.loading = true;
        await this.service.render();
        let res = await wiz.call("stats");
        if (res.code === 200) {
            this.stats = res.data;
            this.datasets = res.data.datasets || [];
        }
        this.loading = false;
        await this.service.render();
    }

    public get userName(): string {
        return this.service.auth.session?.name || '사용자';
    }

    public statusLabel(status: string): string {
        const map: any = { draft: '준비', generating: '생성중', review: '검수중', completed: '마감' };
        return map[status] || status;
    }

    public statusColor(status: string): string {
        const map: any = {
            draft: 'bg-zinc-100 text-zinc-500',
            generating: 'bg-amber-50 text-amber-600',
            review: 'bg-blue-50 text-blue-600',
            completed: 'bg-emerald-50 text-emerald-600',
        };
        return map[status] || 'bg-zinc-100 text-zinc-500';
    }

    public progressColor(progress: number): string {
        if (progress >= 100) return 'bg-emerald-500';
        if (progress >= 50) return 'bg-blue-500';
        return 'bg-amber-500';
    }

    public navigateTo(link: string) {
        this.service.href(link);
    }
}

export default PageUserComponent;